module.exports = __webpack_public_path__ + "img/venezia.43301912.png";